import React, {
    useState, useEffect, forwardRef,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// material component
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import Typography from '../Typography/CustomTypography';

import styles from '../../assets/jss/components/popperStyle';

const useStyles = makeStyles(styles);

export const Arrow = forwardRef((props, ref) => {
    const classes = useStyles();
    return (
        <span className={classes.arrow} ref={ref} {...props} />
    );
});

const PopperCustom = (props) => {
    const classes = useStyles(props);
    const {
        isOpen,
        children,
        placement,
        isArrow,
        target,
        title,
        handleClose,
        hasTitle,
    } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [arrowRef, setArrowRef] = useState(null);

    useEffect(() => {
        if (target) {
            setAnchorEl(target);
        }
    }, [target]);

    const handleArrowRef = (node) => {
        setArrowRef(node);
    };

    const handleCloseAway = () => {
        if (handleClose) {
            handleClose();
        }
    };

    const classPopper = classNames({
        [classes[placement]]: placement,
        [classes.pop]: true,
    });

    return (
        <Popper
            className={classPopper}
            open={isOpen}
            anchorEl={anchorEl}
            placement={placement}
            transition
            disablePortal
            modifiers={{
                arrow: {
                    enabled: isArrow,
                    element: arrowRef,
                },
                flip: {
                    enabled: false,
                },
            }}
        >
            {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={handleCloseAway}>
                    <Fade {...TransitionProps} in={isOpen}>
                        <Paper variant="outlined" className={classes.paper}>
                            {hasTitle && (
                                <Typography variant="body1" className={classes.typography}>
                                    {title}
                                </Typography>
                            )}
                            <Box className={classes.root}>
                                <span className={classes.arrow} ref={handleArrowRef} />
                                {children}
                            </Box>
                        </Paper>
                    </Fade>
                </ClickAwayListener>
            )}
        </Popper>
    );
};

PopperCustom.defaultProps = {
    isOpen: false,
    placement: 'bottom',
    isArrow: true,
    title: '',
    hasTitle: false,
    target: null,
};

PopperCustom.propTypes = {
    isOpen: PropTypes.bool,
    children: PropTypes.element.isRequired,
    placement: PropTypes.oneOf([
        'top',
        'top-start',
        'top-end',
        'right',
        'right-start',
        'right-end',
        'bottom',
        'bottom-start',
        'bottom-end',
        'left',
        'left-start',
        'left-end',
    ]),
    isArrow: PropTypes.bool,
    target: PropTypes.oneOfType([() => null, PropTypes.element, PropTypes.object]),
    title: PropTypes.string,
    handleClose: PropTypes.func.isRequired,
    hasTitle: PropTypes.bool,
};

export default PopperCustom;
